<div *ngIf="loader==false; else elseBlock" class="spinner" >
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>


<ng-template #elseBlock>
  <div style="display: flex; justify-content: center;">
    <mat-form-field appearance="outline" class="divInputSearch">
      <mat-label>Filtrar</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar Búsqueda" />
    </mat-form-field>
  </div>

  <table *ngIf="loader" mat-table style="width: 100%;table-layout: fixed" [dataSource]="dataSource"
    multiTemplateDataRows class="mat-elevation-z8">


    <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns2">
      <th mat-header-cell *matHeaderCellDef> {{column}} </th>
      <td mat-cell *matCellDef="let element"> {{element[column]}} </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef>-</th>
      <td mat-cell *matCellDef="let element; let i =dataIndex" (click)="$event.stopPropagation()">
        <button (click)="openDialogEdit(element.fileId,element.fileProductId)" mat-icon-button color="primary">
          <mat-icon class="icon-color">edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button aria-label="expand row"
          (click)="(modelExpand = modelExpand === element ? null : element); $event.stopPropagation()">
          <mat-icon  class="icon-color"  *ngIf="modelExpand !== element">keyboard_arrow_down</mat-icon>
          <mat-icon  class="icon-color" *ngIf="modelExpand === element">keyboard_arrow_up</mat-icon>
        </button>
      </td>
    </ng-container>


    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
        <div class="example-element-detail" [@detailExpand]="element == modelExpand ? 'expanded' : 'collapsed'">


          <div class="example-element-description"  *ngIf="element == modelExpand ? true : false">

            <div *ngFor="let row of element.services">
              <div *ngIf="row.isDeleted!==true">
                <div style="display: flex">
                  <div style="opacity: 0.5;width: 15em">
                    {{row.categoriaServicio}}
                  </div>
                  <div style="opacity: 0.5;width: 0.5em">
                    {{row.nombre}}
                  </div>
                </div>

              </div>
            </div>
            <br>

            <!--            <div *ngFor="let row of element.services"  >-->
            <!--                <div *ngIf="row.isArchived==false" >-->
            <!--                  <div style="float: left;width: 15em;opacity: 0.5">-->
            <!--                    {{row.categoriaServicio}}-->
            <!--                  </div>-->

            <!--                </div>-->
            <!--              </div>-->
            <!--            <br>-->
            <!--            <div *ngFor="let row of element.services"  >-->
            <!--              <div *ngIf="row.isArchived==false">-->
            <!--                <div style="float: left;width: 15em;opacity: 0.5">-->
            <!--                  {{row.nombre}}-->
            <!--                </div>-->

            <!--              </div>-->
            <!--            </div>-->


          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
    <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;" class="example-element-row"
      [class.example-expanded-row]="modelExpand === element"
      (click)="modelExpand = modelExpand === element ? null : element">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>

  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
  </mat-paginator>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;">
  </mat-row>

  <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator> -->
</ng-template>